import { Component, inject, Input, OnInit } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';
import { I18nService } from '../../../core/services/i18n.service';

@Component({
  selector: 'sps-custom-icon',
  imports: [
    Tooltip
  ],
  templateUrl: './sps-custom-icon.component.html',
})
export class SpsCustomIconComponent implements OnInit {

  i18n = inject(I18nService);

  @Input() name: string;
  @Input() size: number = 14;
  @Input() width: number = undefined;
  @Input() height: number = undefined;
  @Input() alt: string = undefined;
  @Input() tooltip: string = undefined;

  ngOnInit(): void {
    if (this.width === undefined) {
      this.width = this.size;
    }
    if (this.height === undefined) {
      this.height = this.size;
    }
    if (this.alt === undefined) {
      this.alt = this.name;
    }
    try {
      if (this.i18n.i18nLng()[this.alt]) {
        this.alt = this.i18n.i18nLng()[this.alt];
      }
    } catch (e) {
    }
  }
}
